<template>
    <!-- route.meta.layout 이 확정될 때까지 렌더링 지연 —
         defineAsyncComponent + fallback 'default' 조합으로 인해 register/blank 경로에서
         첫 페인트에 default 헤더 네비바가 순간 flash 되던 사고 방지. -->
    <component v-if="layoutReady" :is="layout">
        <router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in">
                <component :is="Component" />
            </transition>
        </router-view>
    </component>
    <Toaster position="top-right" :rich-colors="true" />
</template>

<script setup>
import { computed, watch, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';
import { Toaster } from '@/components/ui/sonner';

const route = useRoute();

// Lazy-loaded layouts - only load when needed
const layouts = {
    default: defineAsyncComponent(() => import('./layouts/DefaultLayout.vue')),
    auth: defineAsyncComponent(() => import('./layouts/AuthLayout.vue')),
    register: defineAsyncComponent(() => import('./layouts/RegisterLayout.vue')),
    blank: defineAsyncComponent(() => import('./layouts/BlankLayout.vue')),
    consent: defineAsyncComponent(() => import('./layouts/ConsentLayout.vue')),
};

// route matched 완료 + meta.layout resolve 후에만 layout 확정.
// 이전엔 fallback 'default' 로 즉시 렌더 → 첫 페인트에 헤더 네비바 flash.
const layoutReady = computed(() => route.matched && route.matched.length > 0);
const layout = computed(() => {
    const layoutName = route.meta?.layout || 'default';
    return layouts[layoutName] || layouts.default;
});

// Update document title based on route
watch(
    () => route.meta?.title,
    (title) => {
        document.title = title ? `WMD PASS - ${title}` : 'WMD PASS';
    }
);
</script>

<style>
/* Fade transition with slide */
.fade-enter-active {
    transition: all 0.2s ease-out;
}

.fade-leave-active {
    transition: all 0.15s ease-in;
}

.fade-enter-from {
    opacity: 0;
    transform: translateY(8px);
}

.fade-leave-to {
    opacity: 0;
    transform: translateY(-4px);
}

/* Smooth page scale effect */
.fade-enter-active,
.fade-leave-active {
    transform-origin: center top;
}
</style>
